import React, {Component} from 'react';
import {Row, Col, Card, } from 'react-materialize';
import Home from '../../components/home/home';
import explanation from '../../images/explanation.png'
import hazards from '../../images/hazard2.png';
import hierarchy from '../../images/hierarchy.png';
import hierarquia from '../../images/hierarquia.png';

import hierarchy_image from '../../images/hierarchy_image.png';

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

import {injectIntl, intlShape} from 'react-intl';

const Riscos = ({intl}) => {



        return (
        <Card>
            <Row className={"valign-wrapper"}>

                <Col s={2} m={2}>
                    <div align="center">
                        <img src={explanation} className={"img"}/></div>

                </Col>

                <Col s={10} m={10}>

                    <p><h5><b> <FormattedMessage id={"risks"} defaultMessage={"Explicação rápida de riscos"}/> </b></h5>
                    </p>

                    <br/>
                    <div align="justify">
                        <p><FormattedMessage id={"risks.text"}
                                             defaultMessage={"Risco ocupacional é a probabilidade de ocorrência de um dano devido a exposição ao perigo (OHSAS 18001). Nas atividades de aquicultura, os trabalhadores e outros colaboradores estão expostos a diferentes riscos, que podem ser físicos, químicos, biológicos, ergonômicos e de acidentes. Para evitar ou mitigar os riscos, é necessário estabelecer controle e gerenciamento de riscos."}/>
                        </p>
                    </div>
                </Col>

            </Row>

            <Row className={"valign-wrapper"}>

                <Col s={2} m={2}>
                    <div align="center">
                        <img src={hierarchy} className={"img"}/></div>
                </Col>

                <Col s={10} m={10}>
                    <p><h5><b><FormattedMessage id={"hierarchy"} defaultMessage={"Hierarquia de controle"}/></b></h5>
                    </p>
                    <br/>
                    <div align="justify">

                        <p><FormattedHTMLMessage id={"hierarchy.text1"}
                                                 defaultMessage={"De acordo com a OSHA, controles efetivos protegem os trabalhadores dos perigos do local de trabalho. Existe uma grande quantidade de informações para ajudar os empregadores a investigar opções para o controle de riscos identificados. Antes de selecionar qualquer opção de controle, é essencial solicitar informações dos stakeholders  (trabalhadores e empregadores) sobre sua viabilidade e eficácia."}/>
                        </p>

                        <ul className={"browser-default"}>
                            <li><FormattedMessage id={"hierarchy.text2"}
                                                  defaultMessage={"Os empregadores devem selecionar os controles mais viáveis, eficazes e permanentes."}/>
                            </li>

                            <li><FormattedMessage id={"hierarchy.text3"}
                                                  defaultMessage={"Selecionar os controles de acordo com uma hierarquia que enfatize soluções incluindo eliminação ou substituição primeiro, seguidas por práticas seguras de trabalho, controles administrativos e, finalmente, equipamentos de proteção individual."}/>
                            </li>
                            <li><FormattedMessage id={"hierarchy.text4"}
                                                  defaultMessage={"Evite selecionar controles que possam, direta ou indiretamente, introduzir novos perigos."}/>
                            </li>
                        </ul>
                    </div>
                </Col>
                {/*IMAGEM DA HIERARQUIA DE CONTROLE*/}

            </Row>
            <Row>
            <React.Fragment>
                <div className={"text-center"} align="center">
                {
                    intl.locale === "en" ?
                        <img src={hierarchy_image} className={"hierarchy"} alt={"Hierarchy img"}/>
                        :
                        <img src={hierarquia} className={"img"} alt={"Img hierarquia"}/>



                }  </div>
            </React.Fragment>  </Row>

</Card>
    )

}

export default injectIntl(Riscos);